var map = {
	"./badges.svg": "a98e",
	"./bronze.svg": "c98c",
	"./gold.svg": "a64a",
	"./platinum.svg": "0d01",
	"./rosette.svg": "4c95",
	"./silver.svg": "bad5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "065d";